export const BASE_API_URL = "https://api.raybodravesh.ir/"; // api
export const TEMP_FOLDER_SRC = `${BASE_API_URL}Files/UploadDocument/temp/`;
export const TEMP_FOLDER_IMAGE_SRC = `${BASE_API_URL}Files/UploadImages/temp/`;
export const FOLDER_IMAGE_SRC = `${BASE_API_URL}Files/UploadImages/user/small/`;
export const FOLDER_IMAGE_SRC1 = `${BASE_API_URL}Files/UploadImages/logo/small/`;
export const FOLDER_IMAGE_SRC2 = `${BASE_API_URL}Files/UploadImages/supplier/small/`;
export const URLS = {};

URLS.GETPRODUCTSFULLDATA = "api/purchase/v1/purchaseRequest/searchProduct";
URLS.LOGIN = "api/raybodSCM/v1/account";
URLS.CONTRACT = "api/sale/v1/contract";
URLS.USER = "api/SCMManagement/v1/User";
URLS.CUSTOMER = "api/SCMManagement/v1/Customer";
URLS.SUPPLIER = "api/SCMManagement/v1/Supplier";
URLS.PRODUCTGR = "api/SCMManagement/v1/ProductGroup";
URLS.PRODUCTGROUP = "api/SCMManagement/v1/Supplier/ProductGroup";
URLS.CONTRACTSUBJECT = "api/sale/v1/contract/contractSubject";
URLS.MRP = "api/planning/v1/mrp";
URLS.MRPSEARCH_COF = "api/planning/v1/mrp/searchInCOF";
URLS.CALCPLANING = "api/planning/v1/mrp/calculatePlanning";
URLS.UPLOADDOCUMENT = "api/raybodSCM/file/uploadDocument";
URLS.GET_PROVINCE_NAME = "api/raybodSCM/v1/province";
URLS.GET_CONTRACT_CUSTOMER = "api/sale/v1/contract/customer";
URLS.SET_CUSTOMER_ADDRESS = "api/sale/v1/contract/customer/Address";
URLS.TECHNICAL_DOCUMENTS = "api/engineering/v1/technicalProductDoc";

//------------
// -== BOM ==-
//------------
URLS.GET_WAITING_BOM_LIST = "api/engineering/v1/bom/WaitingProducts";
URLS.BOM = "api/engineering/v1/bom";

//URLS.SEARCH_PRODUCT_FOR_CREATE_BOM = "api/engineering/v1/bom/product";
URLS.SEARCH_PRODUCT_FOR_CREATE_BOM = "api/engineering/v1/bom/searchProducts";
URLS.BOM_GETCHILD_PRODUCT = "api/engineering/v1/bom/getChildProduct";
URLS.GET_BOM_WAITING_BADGE_COUNT =
  "api/engineering/v1/bom/WaitingProductBadgeCount";
URLS.GET_PRODUCT_DATA = "api/engineering/v1/bom/product";
//-----------------------------------
// --== Purchasing Request === --
//-----------------------------------
URLS.GET_PURCHASEREQUEST_SERACHINMRP =
  "api/purchase/v1/purchaseRequest/searchInMrp";
URLS.GET_PURCHASEREQUEST_SERACHINCONTRACT =
  "api/purchase/v1/purchaseRequest/searchInContract";
URLS.GET_PREPAREREQUESTITEMS =
  "api/purchase/v1/purchaseRequest/prepareRequestItems";
URLS.POST_PURCHASEREQUEST = "api/purchase/v1/purchaseRequest";
URLS.GET_PURCHASEREQUEST = "api/purchase/v1/purchaseRequest";
URLS.DELETE_PURCHASEREQUEST = "api/purchase/v1/purchaseRequest";
URLS.GET_PREPAREREQUEST_REGISTERED = "api/purchase/v1/purchaseRequest/register";
URLS.PATCH_PURCHASEREQUEST_CONFIRM = "api/purchase/v1/purchaseRequest/confirm";

URLS.POST_PURCHASEREQUEST_REJECT = "api/purchase/v1/purchaseRequest/reject";
// pending from: - restFUL
//api/purchase/v1/purchaseRequest/{purchaseRequestId}/purchaseRequestItem
//ViewListModal:  - restFUL
//api/purchase/v1/purchaseRequest/{purchaseRequestId}/purchaseRequestItem/{purchaseRequestItemId}

//-----------------------------------
// --== Technical Product === --
//-----------------------------------
URLS.GET_TECHNICALPRODUCT = "api/engineering/v1/technicalProductDoc";
URLS.GET_TECHNICALDOCUMENT_CONTRACT =
  "api/engineering/v1/technicalProductDoc/contracts";

//-----------------------------------
// --== RFP === --
//-----------------------------------
URLS.GET_VALIDPURCHASEREQUEST = "api/purchase/v1/RFP/validPurchaseRequest";

//GET PURCHASE REQUEST ITEMS
//api/purchase/v1/RFP/{purchaseRequestId}/getPurchaseRequestItems

//GET SUPPLIRE SUPPORT PRODUCT - restFUL
//api/purchase/v1/RFP/{purchaseRequestId}/supplierSupportProduct

URLS.POST_RFP = "api/purchase/v1/RFP";
URLS.PUT_RFP = "api/purchase/v1/RFP";

//-----------------------------------
// --===== Purchase Contract ==== --
//-----------------------------------
URLS.POST_PURCHASE_CONTRACT = "api/purchaseManagement/v1/prContract";
URLS.GET_SUPPLIERS = "api/purchaseManagement/v1/PO/supplier";

//-----------------------------------
// --===== PO ==== --
//-----------------------------------
URLS.GET_PO_PENDING_LIST = "api/purchaseManagement/v1/PO/pendding";
URLS.GET_PO_REGISTERED_LIST = "api/purchaseManagement/v1/PO";

//--- ::REDUX:: ---
//-----------------------------------
export const EVENTS = {};
EVENTS.SET_USER_AUTHENTICATION = "SET_USER_AUTHENTICATION";
EVENTS.SET_USER_TOKEN = "SET_USER_TOKEN";
EVENTS.SET_USER_REFRESH_TOKEN = "SET_USER_REFRESH_TOKEN";
EVENTS.SET_USER_INFO = "SET_USER_INFO";
EVENTS.UPDATE_USER_INFO = "UPDATE_USER_INFO";
EVENTS.LOGIN_HAS_ERRORS = "LOGIN_HAS_ERRORS";
EVENTS.LOGIN_IN_PROGRESS = "LOGIN_IN_PROGRESS";
EVENTS.LOGIN_IS_DONE = "LOGIN_IS_DONE";
EVENTS.UPDATE_USER_LANGUAGE = "UPDATE_USER_LANGUAGE";

EVENTS.INVALID_TOKEN = "INVALID_TOKEN";
EVENTS.REFRESHING_TOKEN = "REFRESHING_TOKEN";
EVENTS.TOKEN_REFRESHED = "TOKEN_REFRESHED";
EVENTS.SET_UNAUTHORIZED_REQUESTS_TO_BUFFER =
  "SET_UNAUTHORIZED_REQUESTS_TO_BUFFER";
EVENTS.CHANGE_PASSWORD_MODAL = "CHANGE_PASSWORD_MODAL";

EVENTS.AJAX_FETCHED_DATA = "AJAX_FETCHED_DATA";
EVENTS.AJAX_HAS_ERROR = "AJAX_HAS_ERROR";
EVENTS.AJAX_IN_PROGRESS = "AJAX_IN_PROGRESS";
EVENTS.AJAX_IS_DONE = "AJAX_IS_DONE";
//==SCM MANAGEMENT DOCS
URLS.GET_CONTRACTS_FOR_TEAM_WORK = "api/SCMManagement/v1/teamWork/GetContracts";
URLS.GET_PRODUCT_GROUP = "api/SCMManagement/v1/teamWork/getProductGroups";
URLS.GET_USERS_FOR_TEAM_WORK = "api/SCMManagement/v1/TeamWork/users";
URLS.SET_NEW_TEAM_WORK = "api/SCMManagement/v1/teamWork";
URLS.GET_TEAM_WORK = "api/SCMManagement/v1/teamWork";
